// src/services/surveyService.js
import { apiService } from './api';

export const surveyService = {
  // Récupérer toutes les enquêtes (admin)
  getSurveys: async () => {
    try {
      const response = await apiService.get('/surveys/supadmin', {}, true);
      return response.data || response;
    } catch (error) {
      console.error('❌ Erreur getSurveys:', error);
      throw error;
    }
  },

  // Créer une enquête - ✅ CORRIGÉ
  createSurvey: async (surveyData) => {
    try {
      const cleanData = {
        title: surveyData.title || '',
        description: surveyData.description || '',
        questions: surveyData.questions || [],
        isActive: surveyData.isActive !== undefined ? surveyData.isActive : true,
        targetCompanies: surveyData.targetCompanies || [],
        startDate: surveyData.startDate,
        endDate: surveyData.endDate
      };
      
      // 🔥 RETIRER le 3ème paramètre 'true'
      const response = await apiService.post('/surveys/supadmin', cleanData);
      return response.data;
    } catch (error) {
      console.error('❌ Erreur createSurvey:', error);
      throw error;
    }
  },

  // Modifier une enquête - ✅ DÉJÀ CORRECT
  updateSurvey: async (surveyId, surveyData) => {
    try {
      console.log('🔄 updateSurvey appelé avec:', surveyId, surveyData);
      const cleanData = {
        title: surveyData.title || '',
        description: surveyData.description || '',
        questions: surveyData.questions || [],
        isActive: surveyData.isActive !== undefined ? surveyData.isActive : true,
        targetCompanies: surveyData.targetCompanies || [],
        startDate: surveyData.startDate,
        endDate: surveyData.endDate
      };
      
      const response = await apiService.put(`/surveys/supadmin/${surveyId}`, cleanData);
      return response.data;
    } catch (error) {
      console.error('❌ Erreur updateSurvey:', error);
      throw error;
    }
  },

  // Supprimer une enquête
  deleteSurvey: async (surveyId) => {
    try {
      const response = await apiService.delete(`/surveys/supadmin/${surveyId}`, {}, true);
      return response.data;
    } catch (error) {
      console.error('❌ Erreur deleteSurvey:', error);
      throw error;
    }
  },

  // Récupérer les réponses d'une enquête
  getSurveyResponses: async (surveyId) => {
    try {
      const response = await apiService.get(`/surveys/supadmin/${surveyId}/responses`, {}, true);
      return response.data || response;
    } catch (error) {
      console.error('❌ Erreur getSurveyResponses:', error);
      throw error;
    }
  }
};